import { AxiosInstance } from "axios";
import { IOrder } from "types/order";
import { buildQueryStringParameters } from "utils/urlEncode";
import { PaginatedList } from "./types";
import { toast } from "react-hot-toast";

const orderUrl = "order";

class OrderApi {
	http: AxiosInstance;
	constructor(axiosInstance: AxiosInstance) {
		this.http = axiosInstance;
	}

	get = (queryParams: { page?: number; size?: number; status?: "open" | "past" }) =>
		this.http.get<PaginatedList<IOrder>>(orderUrl + buildQueryStringParameters(queryParams));
	close = (orderId: number) => this.http.put<IOrder>(orderUrl + "/close/" + orderId);
	refund = (orderId: number) => this.http.put<IOrder>(orderUrl + "/cancel/" + orderId);
	closeAll = () => this.http.put<number>(orderUrl + "/close-all");
	print = (orderId: number) => this.http.post(orderUrl + "/print/" + orderId);
}

export default OrderApi;
